module.exports = __webpack_public_path__ + "static/yolcu-detail2-d6b6922c34096bc239af7a7011fb64a1.png";